<template>
    <div :class="{'text-left': alignLeft,'text-white': textWhite}" class="section-header">
        <p data-type="main-text">{{title}}</p>
        <p data-type="main-text">{{desc}}</p>
    </div>
</template>

<script>
export default {
    name: 'SectionHeader',
    props: {
        title: String,
        desc: String,
        alignLeft: Boolean,
        textWhite: Boolean
    }
}
</script>

<style lang="scss" scoped>
$mob_title: 23px;
$title_line_height: 31px;

div.section-header {
    text-align: center;
    margin-bottom: 87px;
    &.text-white {
        p {
            color: #ffffff !important;
        }
    }
    p {
        &:first-child {
            font-family: 'EinaBold';
            font-size: 32px;
            line-height: 48px;
        }
        &:last-child {
            font-size: 18px;
            line-height: 28px;
        }
    }
}
@media (max-width: 767px) { 
    div.section-header {
        margin-bottom: 16px;
        p {
            &:first-child {
                font-size: $mob_title;
                line-height: $title_line_height;
            }
        }
    }
}
@media (max-width: 576px) {
    div.section-header {
        text-align: center !important;
    }
}
</style>